<div class="tree-search">
  <div class="tree-search__empty" *ngIf="searchResults.length === 0">
    No results
  </div>

  <!-- Tree -->
  <div *ngIf="displayMode === treeSearchDisplayMode.Tree" class="pr-3 pv-3">
    <app-tree class="tree-search__tree" [theme]="theme" [searchGraph]="searchGraph">
    </app-tree>
  </div>

  <!-- List -->
  <cdk-virtual-scroll-viewport
    [itemSize]="64"
    class="pv-3"
    *ngIf="displayMode === treeSearchDisplayMode.List"
    [style.height.px]="searchHeight">
    
    <div 
      *cdkVirtualFor="let node of searchResults; trackBy: trackTreeNode">
      <app-tree-nested-node
        style="height: 64px;"
        class="mr-3"
        [theme]="theme"
        [nested]="false"
        [node]="node"
        [graph]="prunedViewGraph"
        >
      </app-tree-nested-node>
    </div>
  </cdk-virtual-scroll-viewport>
</div>